import { render } from "./VideoMeeting.vue?vue&type=template&id=671d0e2a&scoped=true"
import script from "./VideoMeeting.vue?vue&type=script&lang=js"
export * from "./VideoMeeting.vue?vue&type=script&lang=js"

import "./VideoMeeting.vue?vue&type=style&index=0&id=671d0e2a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671d0e2a"]])

export default __exports__